import type { ReasonForNoResults } from '../../components/no-results/no-results';
import type { ListingsService } from './listings';

import { Environment } from '../../../environments/environment';
import { HasFilters } from '../filtering/has-filters';

export function NoResultsReason(this: ListingsService): ReasonForNoResults {
  if (this.filteringService.reps() || this.filteringService.reps()) {
    return 'rep';
  } else if (this.filteringService.models().length) {
    return 'model';
  } else if (geoWithinChanged.call(this)) {
    return 'map';
  }

  // Defaults to general.
  return 'general';
}

function geoWithinChanged(this: ListingsService): boolean {
  // The map is not the reason for no results if other filters are applied.
  if (HasFilters.call(this.filteringService, false)) {
    return false;
  }

  let output = false;

  if (this.filteringService.lat() !== Environment.mapCenter[0]) {
    output = true;
  }
  if (this.filteringService.lng() !== Environment.mapCenter[1]) {
    output = true;
  }

  return output;
}
